import { render, staticRenderFns } from "./PartnerEditor.vue?vue&type=template&id=7ecfa8d6&"
import script from "./PartnerEditor.vue?vue&type=script&lang=ts&"
export * from "./PartnerEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports